module.exports = __webpack_public_path__ + "static/media/refreshIcon.8ceea899.svg";